import { parseStringPromise } from 'xml2js'

export default async function parseData( data ) {
    let APIResults = await parseStringPromise( data )
    APIResults = APIResults.content.collection[0].data
    if (!APIResults) return []
    APIResults = APIResults.filter( res => res != undefined)
    return APIResults.map( element => element.$)
  }
  